import config from "config/config";
import type { LanguageCode } from "config/languages";
import type { RegularPageName, RegularPageUrls, StoryblokPageName } from "./types";

export const languagesWithoutMagnitudePages: LanguageCode[] = ["ro-md"];

export const storyblokPages: Record<StoryblokPageName, number> = {
  airPassengerRights: 71636182,
  affiliate: 86291623,
  help: 90578664,
  privacy: 52663019,
  terms: 43841167,
  referralTerms: 59199425,
  affiliateTerms: 71636190,
  affiliatePrivacy: 77511577,
  airhelpPlus: 168095828,
  airPayout: 234864063,
};

export const regularPages: Record<RegularPageName, RegularPageUrls> = {
  cookies: {
    fallback: "cookies",
    fi: "evasteet",
    nb: "informasjonskapsler",
  },
  airlineStrikeCompensation: {
    da: "strike/kompensation-for-flystrejke",
    de: "strike/entschaedigung-bei-streik-der-fluggesellschaft",
    el: "strike/αποζημίωση-σε-περίπτωση-απεργίας-αερ",
    en: "strike/airline-strike-compensation",
    es: "strike/compensacion-por-huelga-de-aerolinea",
    fi: "strike/korvaukset-lentolakoista",
    fr: "strike/indemnite-de-greve-des-compagnies-aeriennes",
    it: "strike/risarcimento-per-sciopero-della-compagnia-aerea",
    nb: "strike/kompensasjon-ved-flystreik",
    nl: "strike/compensatie-voor-staking-van-de-luchtvaartmaatschappij",
    pl: "strike/odszkodowanie-za-lot-zaklocony-wskutek-strajku-linii-lotniczej",
    "pt-br": "strike/indenizacao-greve-companhias-aereas",
    "pt-pt": "strike/compensacao-por-greve-da-companhia-aerea",
    ro: "strike/despagubiri-datorate-pentru-greva-la-compania-aeriana",
    ru: "strike/компенсация-в-случае-забастовки-рабо",
    sv: "strike/ersattning-for-flygstrejk",
    isMagnitude: true,
  },
  airlines: {
    da: "airlines",
    de: "airlines",
    el: "airlines",
    en: "airlines",
    es: "airlines",
    fi: "airlines",
    it: "airlines",
    fr: "airlines",
    nb: "airlines",
    nl: "airlines",
    pl: "airlines",
    pt: "airlines",
    ro: "airlines",
    ru: "airlines",
    sv: "airlines",
    isMagnitude: true,
  },

  airports: {
    da: "airports",
    de: "airports",
    el: "airports",
    en: "airports",
    es: "airports",
    fi: "airports",
    it: "airports",
    fr: "airports",
    nb: "airports",
    nl: "airports",
    pl: "airports",
    pt: "airports",
    ro: "airports",
    ru: "airports",
    sv: "airports",
    isMagnitude: true,
  },
  webapp: {
    isExternal: true,
    bg: `${config.webappUrl}?lang=bg`,
    cs: `${config.webappUrl}?lang=cs`,
    da: `${config.webappUrl}?lang=da`,
    de: `${config.webappUrl}?lang=de`,
    el: `${config.webappUrl}?lang=el`,
    en: `${config.webappUrl}?lang=en`,
    es: `${config.webappUrl}?lang=es`,
    fi: `${config.webappUrl}?lang=fi`,
    fr: `${config.webappUrl}?lang=fr`,
    hu: `${config.webappUrl}?lang=hu`,
    it: `${config.webappUrl}?lang=it`,
    nb: `${config.webappUrl}?lang=nb`,
    nl: `${config.webappUrl}?lang=nl`,
    pl: `${config.webappUrl}?lang=pl`,
    "pt-br": `${config.webappUrl}?lang=pt-BR`,
    "pt-pt": `${config.webappUrl}?lang=pt`,
    ro: `${config.webappUrl}?lang=ro`,
    ru: `${config.webappUrl}?lang=ru`,
    sv: `${config.webappUrl}?lang=sv`,
    "zh-cn": `${config.webappUrl}?lang=zh-CN`,
    // tr: `${config.webappUrl}?lang=tr`,
    fallback: `${config.webappUrl}?lang=en`,
  },
  webappNewClaim: {
    isExternal: true,
    bg: `${config.funnelUrl}/claims/new?lang=bg`,
    cs: `${config.funnelUrl}/claims/new?lang=cs`,
    da: `${config.funnelUrl}/claims/new?lang=da`,
    de: `${config.funnelUrl}/claims/new?lang=de`,
    el: `${config.funnelUrl}/claims/new?lang=el`,
    en: `${config.funnelUrl}/claims/new?lang=en`,
    es: `${config.funnelUrl}/claims/new?lang=es`,
    fi: `${config.funnelUrl}/claims/new?lang=fi`,
    fr: `${config.funnelUrl}/claims/new?lang=fr`,
    hu: `${config.funnelUrl}/claims/new?lang=hu`,
    it: `${config.funnelUrl}/claims/new?lang=it`,
    nb: `${config.funnelUrl}/claims/new?lang=nb`,
    nl: `${config.funnelUrl}/claims/new?lang=nl`,
    pl: `${config.funnelUrl}/claims/new?lang=pl`,
    "pt-br": `${config.funnelUrl}/claims/new?lang=pt-BR`,
    "pt-pt": `${config.funnelUrl}/claims/new?lang=pt`,
    ro: `${config.funnelUrl}/claims/new?lang=ro`,
    ru: `${config.funnelUrl}/claims/new?lang=ru`,
    sv: `${config.funnelUrl}/claims/new?lang=sv`,
    "zh-cn": `${config.funnelUrl}/claims/new?lang=zh-CN`,
    // tr: `${config.funnelUrl}/claims/new?lang=tr`,
    fallback: `${config.funnelUrl}/claims/new?lang=en`,
  },

  webappBarcodeScanner: {
    isExternal: true,
    fallback: `${config.funnelUrl}/claims/barcode/scanner?lang=en`,
  },

  webappBarcodeUploader: {
    isExternal: true,
    fallback: `${config.funnelUrl}/claims/barcode/uploader?lang=en`,
  },

  careers: {
    isExternal: true,
    fallback: "https://careers.airhelp.com/",
  },
};
